export const isProd = import.meta.env.VITE_APP_STATION_ENV === 'production';
